export const EVENT_NAMES = {
  ABORT_REQUEST: 'abortRequest',
};
